import { render } from "./ModalSimularPoliticas.vue?vue&type=template&id=a877801e"
import script from "./ModalSimularPoliticas.vue?vue&type=script&lang=js"
export * from "./ModalSimularPoliticas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__